import type { SupportedPlatformLanguageCode as SupportedLocale } from '@tov-plus/domain';
import adminWebsiteEnMessages from './admin-website/en.json';
import adminWebsiteHeMessages from './admin-website/he.json';
import commonEnMessages from './common/en.json';
import commonHeMessages from './common/he.json';
import communicationsServiceEnMessages from './communications-service/en.json';
import communicationsServiceHeMessages from './communications-service/he.json';
import dashboardWebsiteEnMessages from './dashboard-website/en.json';
import dashboardWebsiteHeMessages from './dashboard-website/he.json';
import documentationWebsiteEnMessages from './documentation-website/en.json';
import documentationWebsiteHeMessages from './documentation-website/he.json';
import guestsWebsiteEnMessages from './guests-website/en.json';
import guestsWebsiteHeMessages from './guests-website/he.json';
import identityServiceEnMessages from './identity-service/en.json';
import identityServiceHeMessages from './identity-service/he.json';
import landingWebsiteEnMessages from './landing-website/en.json';
import landingWebsiteHeMessages from './landing-website/he.json';
import vendorsWebsiteEnMessages from './vendors-website/en.json';
import vendorsWebsiteHeMessages from './vendors-website/he.json';

export const LOCALIZATION_COMPONENTS = [
  'common',
  'dashboard-website',
  'guests-website',
  'admin-website',
  'vendors-website',
  'landing-website',
  'documentation-website',
  'communications-service',
  'identity-service',
] as const;
export type LocalizationComponent = (typeof LOCALIZATION_COMPONENTS)[number];
type MessageCatalog = Record<string, string>;
export type ComponentCatalogs = Record<SupportedLocale, MessageCatalog>;

export const componentCatalogs: Record<
  LocalizationComponent,
  ComponentCatalogs
> = {
  common: {
    en: commonEnMessages,
    he: commonHeMessages,
  },
  'dashboard-website': {
    en: dashboardWebsiteEnMessages,
    he: dashboardWebsiteHeMessages,
  },
  'guests-website': {
    en: guestsWebsiteEnMessages,
    he: guestsWebsiteHeMessages,
  },
  'admin-website': {
    en: adminWebsiteEnMessages,
    he: adminWebsiteHeMessages,
  },
  'vendors-website': {
    en: vendorsWebsiteEnMessages,
    he: vendorsWebsiteHeMessages,
  },
  'landing-website': {
    en: landingWebsiteEnMessages,
    he: landingWebsiteHeMessages,
  },
  'documentation-website': {
    en: documentationWebsiteEnMessages,
    he: documentationWebsiteHeMessages,
  },
  'communications-service': {
    en: communicationsServiceEnMessages,
    he: communicationsServiceHeMessages,
  },
  'identity-service': {
    en: identityServiceEnMessages,
    he: identityServiceHeMessages,
  },
};

// Pure lookup for server and static renderers. Never changes the active UI locale.
export function msgForComponent(
  id: string,
  locale: string | null | undefined,
  component: LocalizationComponent,
): string {
  const normalizedLocale =
    locale?.trim().toLowerCase().split(/[-_]/)[0] === 'he' ? 'he' : 'en';
  const messages = componentCatalogs[component];
  const value =
    messages[normalizedLocale][id] ||
    componentCatalogs.common[normalizedLocale][id];
  if (value?.trim()) return value;
  const fallback = messages.en[id] || componentCatalogs.common.en[id];
  return fallback?.trim()
    ? fallback
    : componentCatalogs.common[normalizedLocale][
        'general.localization.text_unavailable'
      ]!;
}
